module.exports = __webpack_public_path__ + "img/wes-hicks-4-EeTnaC1S4.dd71f953.png";